import React, {useEffect} from 'react';
import {useQuery, gql} from '@apollo/client';
import {useNavigate, useParams} from 'react-router-dom';

export const GET_NATIVE_ID_AND_ACCOUNT = gql`
  query NativeIdAndAccount(
    $modelName: OneViewModelTypesEnum!
    $curoId: UUID
    $nativeId: UUID
  ) {
    nativeIdAndAccount(modelName: $modelName, curoId: $curoId, nativeId: $nativeId) {
      accountId
      accountCuroId
      nativeId
      curoId
    }
  }
`;

const ReviewRedirect: React.FC = () => {
  const {curoReviewId} = useParams<{curoReviewId: string}>();
  const navigate = useNavigate();

  const modelName = 'REVIEW';
  const curoIdValue = curoReviewId;

  const {data, loading, error} = useQuery(GET_NATIVE_ID_AND_ACCOUNT, {
    variables: {
      modelName,
      curoId: curoIdValue,
    },
  });

  useEffect(() => {
    if (data && data.nativeIdAndAccount) {
      const {accountId, nativeId} = data.nativeIdAndAccount;
      if (nativeId && accountId) {
        // both accountId and nativeId are oneview ids not curo ids.
        const redirectUrl = `/account/${accountId}/review-journey/${nativeId}`;
        navigate(redirectUrl);
      }
    }
  }, [data, navigate]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return <p>Redirecting...</p>;
};

export default ReviewRedirect;
